import L from 'leaflet';
import 'leaflet.gridlayer.googlemutant';
import { MapLayer } from 'react-leaflet';

export const MapTypeEnum = {
    Hybrid: 'hybrid',
    Roadmap: 'roadmap',
    Satellite: 'satellite',
    Terrain: 'terrain'
};
export default class GoogleLayer extends MapLayer {
    createLeafletElement(props) {
        const config = { type: 'roadmap', ...props };
        return new L.gridLayer.googleMutant(config);
    }
}

export { GoogleLayer };
